import { useDeleteProgramEngagement } from '@cibo/programs'
import { LoadingButton } from '@mui/lab'
import { Button, ButtonProps, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveDialog } from '../../consts/Theme'
import { EngagementRouteParams } from '../../navigation/types/engagementRoutes'

export const DeleteApplicationButton = ({
  engagementId,
  onSuccess,
  ...buttonProps
}: Pick<EngagementRouteParams, 'engagementId'> &
  Omit<ButtonProps, 'onClick'> & { onSuccess: () => void }) => {
  const { t } = useTranslation('@cibo/impact/DeleteApplicationButton')
  const deleteEngagement = useDeleteProgramEngagement()
  const [open, setOpen] = useState(false)

  const handleUnconfirm = () => {
    !!engagementId &&
      deleteEngagement
        .mutateAsync({
          id: engagementId,
        })
        .then(() => {
          setOpen(false)
          onSuccess()
        })
  }

  return (
    <>
      <Button {...buttonProps} onClick={() => setOpen(true)}>
        {t('deleteApplication')}
      </Button>
      <ResponsiveDialog onClose={() => !deleteEngagement.isLoading && setOpen(false)} open={open}>
        <DialogTitle>{t('title')}</DialogTitle>
        <DialogContent>{t('body')}</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={deleteEngagement.isLoading}>
            {t('cancel')}
          </Button>
          <LoadingButton
            variant="contained"
            color="error"
            loading={deleteEngagement.isLoading}
            onClick={handleUnconfirm}
            sx={{ textTransform: 'uppercase' }}
          >
            {t('delete')}
          </LoadingButton>
        </DialogActions>
      </ResponsiveDialog>
    </>
  )
}
